@if (context$ | async; as context) {
  <article class="d-flex flex-column align-items-center gap-2">
    <img
      class="empty-state"
      ngSrc="assets/images/NOW_Illustration_Suche.svg"
      height="256"
      width="240"
      alt=""
    />
    <p class="text-center">
      {{ context.helpText }}
    </p>
    <div class="now-btn-group">
      @if (context.url) {
        <a [attr.href]="context.url" class="now-btn now-btn-secondary">{{ context.buttonText }}</a>
      }
      @if (showSearchButton$ | async) {
        <button (click)="triggerSearch()" class="now-btn now-btn-primary">
          Alternativen anzeigen
        </button>
      }
    </div>
  </article>
}
